import React from "react";

export function Logo({ variant = "light", className = "" }) {
  const light = variant === "light";
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <img
        src="/logo.png"
        alt="CKISS — Christine Kaatz Integrated Support Services"
        className="h-14 w-14 object-contain"
        style={
          light
            ? { filter: "brightness(0) invert(1)" }
            : undefined
        }
      />
      <div className="leading-tight hidden sm:block">
        <div
          className={`text-[10px] sm:text-[11px] uppercase tracking-[0.22em] font-semibold ${
            light ? "text-white" : "text-brand-navy"
          }`}
        >
          Integrated Support Services
        </div>
        <div
          className={`text-[10px] uppercase tracking-[0.18em] ${
            light ? "text-white/70" : "text-brand-mute"
          }`}
        >
          NDIS Implementation
        </div>
      </div>
    </div>
  );
}
